// extracted by css-extract-rspack-plugin
export default {"cls1":"MentionsCardHeader-cls1_TDu","cls2":"MentionsCardHeader-cls2_iQe MentionsCardHeader-cls1_TDu"};